import ReactDOM from 'react-dom';
import React from 'react';
import { createBrowserHistory } from 'history';
import { syncHistoryWithStore } from 'mobx-react-router';
import { Router } from 'react-router';

import EventStore from './store';
import Events from './components';
import { initToggles, initCount } from '../modules/shortlist';


function initListing(store, history) {
  document.querySelectorAll('[data-event-listing]').forEach(el => {
    const maxEvents = parseInt(el.getAttribute('data-max-events'));
    const displayLargeTiles = el.hasAttribute('data-display-large-tiles');
    ReactDOM.render(
      <Router history={ history }>
        <Events store={ store } maxEvents={ maxEvents } displayLargeTiles={ displayLargeTiles } />
      </Router>,
      el
    );
  });
}


function init() {
  const store = new EventStore(EVENT_LISTING_DATA);
  const { url } = EVENT_LISTING_DATA;
  const browserHistory = createBrowserHistory({
    basename: url,
  });
  const history = syncHistoryWithStore(browserHistory, store.routingStore);
  window.STORE = store;

  store.shortlistStore.loadItems()
    .then(() => {
      initListing(store, history);
      initToggles(store.shortlistStore);
      initCount(store.shortlistStore);
    });
}

export default { init };
